import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import SegmentError from 'personalization-lib/components/targeting/SegmentError';
import { useGetSegmentByIdentifierQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/segment/rpc/SegmentCrudRpc.hooks';
import { getSegmentDetailsUrl } from 'personalization-lib/utils/urls/segments';
import { parseSegmentError } from 'personalization-lib/utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
const SegmentLink = ({
  segmentIdentifier
}) => {
  const {
    data,
    loading,
    error
  } = useGetSegmentByIdentifierQuery({
    variables: {
      identifier: segmentIdentifier
    },
    skip: !segmentIdentifier
  });
  if (error) {
    return /*#__PURE__*/_jsx(Text, {
      use: "error",
      as: "span",
      "data-test-id": "segment-error",
      children: /*#__PURE__*/_jsx(SegmentError, {
        error: parseSegmentError(error)
      })
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      blockSize: "1em",
      inlineSize: "17ch",
      as: "span"
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    href: getSegmentDetailsUrl(segmentIdentifier),
    external: true,
    truncate: true,
    display: "inline-grid" // necessary to avoid content overflowing flex containers
    ,
    children: data === null || data === void 0 ? void 0 : data.segment.name
  });
};
export default SegmentLink;